import { useLogout, useUser } from '@tbitop/authentication';
import { useMandanten } from '@tbitop/mandanten';
import { defaultTo, startCase } from 'lodash-es';
import { ArrowClockwise, SignOut } from 'phosphor-react';
import { ClickableArea } from './clickable-area';
import { OrganisationSelector } from './organisation-selector';

const NotAuthorizedDetail = () => {
  const user = useUser();
  const { currentMandant } = useMandanten();

  return <p>Ihre E-Mail-Adresse {user?.email} ist in der Organisation {startCase(defaultTo(currentMandant?.anzeigename, ''))} für den Sales Planner zur Zeit nicht freigeschaltet.</p>;
};

const OnlyOneOrganisation = () => {
  const logout = useLogout();
  return (
    <>
      <div className="mx-5 mb-3 pt-28">
        <h1 className="mb-3 text-xl">Nicht freigeschaltet</h1>
        <NotAuthorizedDetail />
        <p className="mt-6">Bitte kontaktieren Sie Ihren Administrator und versuchen Sie es erneut.</p>
      </div>
      <div>
        <ClickableArea onClick={() => {
          window.location.reload();
        }} logo={<ArrowClockwise />}>Erneut versuchen</ClickableArea>
        <ClickableArea onClick={logout} logo={<SignOut />}>Abmelden</ClickableArea>
      </div>
    </>
  );
};

const SelectOtherOrganisation = () => {
  return (
    <>
      <div className="mx-5 mb-3 mt-28">
        <h1 className="mb-3 text-xl">Andere Organisation wählen</h1>
        <NotAuthorizedDetail />
        <p className="mt-3">Wählen Sie eine andere Organisation aus und versuchen Sie es erneut.</p>
      </div>
      <OrganisationSelector />
    </>
  );
};

export const NotAuthorizedScreen = () => {
  const { mandanten } = useMandanten();

  return mandanten.length > 1
    ? <SelectOtherOrganisation />
    : <OnlyOneOrganisation />;
};
